import { connect } from 'react-redux';
import SalesLogic from './SalesLogic';
import { getAnnualResults } from '../selectors';

import { setSelectedFinancing } from '../../../../common/settings/actions';

const mapStateToProps = state => ({
    annualResults: getAnnualResults(state),
    companyName: state.clientInfoUI.companyName,
    installType: state.solar.installType,
    installType2: state.solar.installType2,
    systemSize: state.solar.systemSize,
    includeESS: state.ess.includeESS,
    resiToggle: state.tax.resiToggle,
    batteryType: state.ess.batteryType,
    provider: state.utility.provider,
});

const combinedActions = {
    setSelectedFinancing,
};

export default connect(mapStateToProps, combinedActions)(SalesLogic);



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/SalesLogic/index.js